import { cellKey, isOnBoard } from './coordinates';

const DIRECTIONS = Object.freeze([
  [-1, -1], [-1, 0], [-1, 1],
  [0, -1],            [0, 1],
  [1, -1],  [1, 0],  [1, 1],
]);

export const beamCounts = (size, lighthouses) => {
  const counts = new Map();

  lighthouses.forEach(({ row, column }) => {
    DIRECTIONS.forEach(([rowStep, columnStep]) => {
      let nextRow = row + rowStep;
      let nextColumn = column + columnStep;
      while (isOnBoard(size, nextRow, nextColumn)) {
        const key = cellKey(nextRow, nextColumn);
        counts.set(key, (counts.get(key) || 0) + 1);
        nextRow += rowStep;
        nextColumn += columnStep;
      }
    });
  });

  return counts;
};
